

















import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { Dialog } from '@models'

@Component
export default class FormSection extends Vue {
  name = 'form-section';
  @Prop(String) header: string;
  @Prop({ required: false, }) showIcon?: boolean;
  @Prop({ required: false, }) helpText?: string;
  helptTextDialog: Dialog = new Dialog({
    formRef: 'helptTextDialog',
    headline: 'What is this section about?',
    message: "",
    hasCloseBtn: false,
    hasCancelBtn: false,
    isInfoDialog: true,
    useTextArea: true
  });

  showDialog() {
    this.helptTextDialog.visible = true;
  }

  @Watch('helpText')
  onHelpTextChanged(): void {
    this.helptTextDialog.message = this.helpText;
  }

  get showHelpTextIdentifier(): string {
    return this.helpText;
  }
}
